import React from "react";
import PropTypes from "prop-types";
import { Button } from "components/common/button";

export const InvoiceActionsFormatter = (row) => (
  <span><Button link onClick={ () => window.open(row.value) }>Download</Button></span>
);

InvoiceActionsFormatter.propTypes = {
  value: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/invoice-actions-formatter.jsx